import { combineReducers } from 'redux';
import { paymentMethodsReducer } from './paymentMethods';

export const domainReducer = combineReducers({
  paymentMethods: paymentMethodsReducer,
});
